<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <v-btn
                class="mx-2"
                fab
                x-small
                color="primary"
                @click="$router.back()"
              >
                <v-icon dark> mdi-arrow-left </v-icon>
              </v-btn>
              <h3
                class="font-weight-bold"
                v-text="isDeletePage() != true ? 'Order Details' : 'Deleted'"
              ></h3>

              <!-- <template v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small 
                  color="primary"
                  to="/order_details/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </template> -->
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
           
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="900"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-start sr_no">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left" style="min-width: none">Product</th>
                      <th class="text-left" style="min-width: none">
                        Quantity
                      </th>
                      <th class="text-left" style="min-width: none">
                        Selling Price
                      </th>
                      <th class="text-left" style="min-width: none">Total Price</th>
                      <th class="text-left" style="min-width: none">
                        Color
                      </th>
                      <th class="text-left" style="min-width: none">
                        Size
                      </th>
                      <!-- <th class="text-right action_th">Action</th> -->
                    </tr>
                  </thead>
                  <tbody v-if="order_details.length != 0">
                    <tr
                      v-for="(order_detail, i) in order_details"
                      :key="`order_detail_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': order_details.length - 1 == i,
                      }"
                    >
                      <td>
                        &nbsp;{{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="order_detail.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>order detail is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="order_detail.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>order_detail is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{
                          order_detail.product_variant &&
                          order_detail.product_variant.product
                            ? order_detail.product_variant.product.name
                            : ""
                        }}
                      </td>

                      <td>
                        {{ order_detail.quantity || "" }}
                      </td>
                      <td>
                        {{ order_detail.price || "" }}
                      </td>
                      <td>
                        {{ order_detail.total_price || "" }}
                      </td>
                      <td>
                        {{ order_detail.product_variant? order_detail.product_variant.color :"" }}
                      </td>
                      <td>
                        {{ order_detail.product_variant? order_detail.product_variant.size :"" }}
                      </td>
                     
                      <td class="text-right">
                        <template v-if="isDeletePage() != true"> </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(order_detail.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this order_detail</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="7" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_order_detail" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>order_details deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_order_detail = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_store" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>order_detail restored successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_restored_store = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "OrderDetailsPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        is_selected: false,
      },
      stores: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      Exportorder_detailTypes: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
      },
      isLoading: false,
      isExcelloading: false,
      delete_order_detail: false,
      is_deleted_order_detail: false,
      is_select_all: false,
      isDeleteAll: false,
      is_restored_store: false,
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";

      // if (this.$route.params.id) {
      //   this.filter.order_id = this.decryptIt(this.$route.params.id);
      // } else {
      //   this.filter.order_id = "";
      // }
      if (this.$route.query.product_id) {
        this.filter.product_id = this.decryptIt(this.$route.query.product_id);
      } else {
        this.filter.product_id = "";
      }
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&product_id=" +
        this.filter.product_id +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`/orders/${this.$route.params.orderId}/order_details?${query}`)
        .then((response) => {
          this.order_details = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    //Generate Excel
    async generateExcel() {
      let query = "search_keyword=" + this.filter.search_keyword;
      let response = await axios.get(`store_exports?${query}`);
      console.log(response.data.data);
      if (response) {
        window.open(`${response.data.data}`, "_blank");
      }
    },
    async Delete_this(id) {
      this.delete_order_detail = true;
      await axios
        .post(`/order_details/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_order_detail = false;
          this.is_deleted_order_detail = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    selectAll() {
      console.log(this.is_select_all);
      this.order_details.forEach((order_detail) => {
        order_detail.is_selected = this.is_select_all;
      });
    },
    async deleteAll() {
      this.isDeleteAll = true;
      let deleteallIds = [];
      this.order_details.forEach((order_detail) => {
        if (order_detail.is_selected) deleteallIds.push(order_detail);
      });
      await axios
        .post("/order_details/alldelete", { deleteallIds })
        .then(() => {
          this.filter.status = "";
          this.getData();
        })
        .catch(function (error) {
          this.getData();
          console.log(error);
        });
      // let response = await axios.post(/sync_users/update_date_all, this.form);
      this.isDeleteAll = false;
    },
    async Restore_this(id) {
      this.restore_order_detail = true;
      await axios
        .post(`/order_details/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_order_detail = false;
          this.is_restored_order_detail = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          window.location.href = "/auth/login";
        });
    },
  },
};
</script>
